"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactCalendly = require("react-calendly");
var _analytics = _interopRequireWildcard(require("../../../helpers/analytics"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BookCall = function BookCall() {
  (0, _reactCalendly.useCalendlyEventListener)({
    onDateAndTimeSelected: function onDateAndTimeSelected() {
      return _analytics["default"].selectedDateTimeCalendly(true);
    },
    onEventScheduled: function onEventScheduled() {
      return _analytics["default"].scheduledCalendly(true);
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component position-relative"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-left text-md"
  }, "Book a call"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactCalendly.InlineWidget, {
    className: _analytics.GA4_TRIGGERS.BOOK_CALL_CLASS,
    styles: {
      minWidth: '200px',
      height: '600px'
    },
    pageSettings: {
      backgroundColor: 'ffffff',
      hideEventTypeDetails: false,
      hideLandingPageDetails: true,
      primaryColor: '0284fe',
      textColor: '333'
    },
    url: "https://calendly.com/day8/30min?back=1&month=2024-02"
  })));
};
var _default = exports["default"] = BookCall;